import ListBase from '@Component/form/ListBase';
import React, { useEffect } from 'react';
import { history } from '../../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { PAYMENT_STATUS } from './BackOfficeConstant';
import Card from '@Utils/Card';
import { backOfficeFilteredInvoiceListFetch } from '@Redux/slices/account/backOfficeInvoiceSlice';
import { Button } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { readableDate } from '@Utils/DateUtils';

export const BackOfficePreInvoices = () => {
  const dispatch = useDispatch();

  const page = useSelector(
    (state) => state.account.backOffice.backOfficeFilteredInvoiceList
  );

  const pageRequest = useSelector(
    (state) => state.account.backOffice.pageRequest
  );

  const loading = useSelector((state) => state.account.backOffice.loading);

  useEffect(() => {
    dispatch(
      backOfficeFilteredInvoiceListFetch({
        ...pageRequest,
        statuses: ['PROFORMA_INVOICE'],
      })
    );
  }, []);

  const columns = [
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (date) => readableDate(date),
    },
    {
      title: 'Product ID',
      dataIndex: 'contract',
      key: 'contract',
      align: 'center',
      render: (data) => data?.product?.id ?? '-',
    },
    {
      title: 'Product Name',
      dataIndex: 'contract',
      key: 'contract',
      render: (data) => data?.product?.name ?? '-',
    },
    {
      title: 'Invoice Number',
      dataIndex: 'internalNumber',
      key: 'internalNumber',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text) =>
        text ? (
          <span
            className="Status"
            style={{
              fontSize: 11,
              fontWeight: '600',
              padding: '5px 10px',
              textTransform: 'uppercase',
              borderRadius: '50px',
              backgroundColor: PAYMENT_STATUS[text]?.bgColor || '#e7e8e9',
              color: PAYMENT_STATUS[text]?.color || '#94969e',
            }}
          >
            {text}
          </span>
        ) : (
          '-'
        ),
    },
    {
      title: 'Subscription Fee',
      dataIndex: 'basePrice',
      key: 'basePrice',
    },
    {
      title: 'Final Price',
      dataIndex: 'finalPrice',
      key: 'finalPrice',
    },
    {
      title: '',
      dataIndex: '',
      key: '-action-',
      width: '5%',
      render: (_, record) => {
        return (
          <Button
            type="link"
            shape="rounded"
            onClick={() => {
              const id = record?.id;

              history.push(`/back-office/invoice-view/${id}`);
            }}
          >
            <div>
              <ExportOutlined style={{ fontSize: '18px' }} />
            </div>
          </Button>
        );
      },
    },
  ];

  return (
    <Card loading={loading} styles={{ margin: 24, display: 'flex', flex: 1 }}>
      <ListBase
        onChange={(p) =>
          dispatch(
            backOfficeFilteredInvoiceListFetch({
              ...pageRequest,
              page: p.page,
            })
          )
        }
        page={page}
        pageRequest={pageRequest}
        columns={columns}
        createLink={null}
      />
    </Card>
  );
};
